// extracted by mini-css-extract-plugin
module.exports = {"text":"lagSelector_text__2gHXs"};
    if(module.hot) {
      // 1783591905167
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  